import KeyedAndNamedDto from 'modules/base/dto/KeyedAndNamedDto';

export class WorkflowModelOutputAttributeEditDto extends KeyedAndNamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.uom = null;
	}

	/**
	 * @typedef {Object} _WorkflowModelOutputAttributeEditDtoProps
	 * @property {string} value
	 * @property {string} uom
	 *
	 * @typedef {import("modules/base/dto/KeyedAndNamedDto").KeyedAndNamedDtoProps & _WorkflowModelOutputAttributeEditDtoProps} WorkflowModelOutputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {WorkflowModelOutputAttributeEditDtoProps} props
	 * @returns {WorkflowModelOutputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.value = props.value;
		this.uom = props.uom;
		return this;
	}
}

export default WorkflowModelOutputAttributeEditDto;
